import { useInfiniteQuery } from '@tanstack/react-query';

import { type CommonQueryArgs } from '@pkg/hooks';

import { type CollectionChainType } from '@app/client';
import { callGetCollectionToken } from '@app/client/resources/daas';

import { useSearchParamsState } from '../navigation/useSearchParams';

interface GetTokenProps extends CommonQueryArgs {
    slug: string;
    chain?: CollectionChainType;
}
export function useGetCollectionTokensV2({ slug, limit = 50, disabled, chain }: GetTokenProps) {
    const { params } = useSearchParamsState<Record<string, string>>();

    const cache = [`collection-tokens`, slug, limit, JSON.stringify(params)];
    return useInfiniteQuery({
        queryKey: cache,
        queryFn: ({ pageParam }) =>
            callGetCollectionToken({
                ordering: 'listing_price',
                direction: 'asc',
                collectionSlug: chain ? `${chain?.toLowerCase()}.${slug}` : slug,
                query: {
                    limit,
                    ...params,
                    ...(pageParam ? { continuation: pageParam } : {}),
                },
            }),
        retry: false,
        enabled: Boolean(slug) && !disabled,
        initialPageParam: '',
        getNextPageParam: (params) => params?.continuation,
    });
}
